export const saveServiceCategoria = (api, props, controller) => {
  return api.post('secoes_categoria', props, {
    signal: controller.signal,
  });
};